import { clients } from '@moovly/clients';
import { UserProfile } from '@moovly/clients/lib/resources/users/users.interfaces';
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { DefaultApiRequestState, getDefaultApiRequestState, getDefaultReducerForAsyncRequest } from './default';
import { License } from '@moovly/clients/lib/resources/licenses/licenses.interfaces';

// Types
type AuthState = {
  isAuthenticated: boolean;
  user: DefaultApiRequestState<UserProfile>;
  license: DefaultApiRequestState<License>;
};

export const getCurrentUser = createAsyncThunk('auth/getUser', () => {
  return clients.Users.getUserProfile();
});

export const getCurrentLicense = createAsyncThunk('auth/getLicense', () => {
  return clients.Licenses.getUserLicense();
});

const initialState: AuthState = {
  isAuthenticated: false,
  user: getDefaultApiRequestState(),
  license: getDefaultApiRequestState(),
};

export const authSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {
    isAuthenticated: (state, { payload }: PayloadAction<boolean>) => {
      state.isAuthenticated = payload;
    },
  },
  extraReducers: {
    ...getDefaultReducerForAsyncRequest({
      thunk: getCurrentUser,
      getInitialState: (state) => state.user,
    }),
    ...getDefaultReducerForAsyncRequest({
      thunk: getCurrentLicense,
      getInitialState: (state) => state.license,
    }),
  },
});

export default authSlice;
